export default {
    data() {
        return {
            alert: {
                isshow: false,
            },
            headPanelBg: require("../../../shared/assets/images/user/bg_user_header.jpg"),
            isLogin: this.$isLogin(),
            info: {},
            isShowReleaseClientJobConfirmPanel: false, //是否显示发布订单须知面板
            helpPartner: { //招募合伙人详情
                id: 101,
                title: "招募合伙人",
                content: "<div class='item' style='width:100%;padding:0.2rem 0 0.06rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;font-weight:bold;'><span class='bullet'>1.</span><p>U+合伙人的独特价值</p></div>" +
                    "<div class='item' style='width:100%;padding:0;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'></span><p>随时随地为客户寻找合适的服务师；</p></div>" +
                    "<div class='item' style='width:100%;padding:0 0 0.14rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'></span><p>高效的连接客户和服务师。</p></div>" +
                    "<div class='item' style='width:100%;padding:0.2rem 0 0.06rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;font-weight:bold;'><span class='bullet'>2.</span><p>合伙人的资格认定</p></div>" +
                    "<div class='item' style='width:100%;padding:0;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'></span><p>也许你退休了，但是只要你有充足的时间；</p></div>" +
                    "<div class='item' style='width:100%;padding:0 0 0.14rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'></span><p>也许你从来都不了解这个行业，但是只要你具有与他人进行良好的沟通能力，我们还需要你有强大的责任心</p></div>" +
                    "<div class='item' style='width:100%;padding:0.2rem 0 0.06rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;font-weight:bold;'><span class='bullet'>3.</span><p>申请成为合伙人</p></div>" +
                    "<div class='item' style='width:100%;padding:0;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'></span><p>想成为坐拥众多服务师的合伙人么？</p></div>" +
                    "<div class='item' style='width:100%;padding:0;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'></span><p>想拥有一份事业么？</p></div>" +
                    "<div class='item' style='width:100%;padding:0 0 0.14rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'></span><p>请点此下载U+私人管家（商户版）注册后等待审核。</p></div>",
            },
            curHelpDetail: {},
            isShowHelpDetail: false, //是否显示招募合伙人详情
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'center') {
                this.init();
            }
        }
    },
    methods: {
        init() {
            let self = this;
            this.isLogin = this.$isLogin();
            // this.$detectLogin();
            if (!this.isLogin) {
                dsBridge.call("login", "", function(session) {
                    window.sessionStorage.setItem("session", session);
                    self.isLogin = self.$isLogin();
                });
            }
            this.getInfo();
        },
        //获取账户数据
        getInfo() {
            let _this = this;
            this.$post("/customerservicemanager/accountinfo", function(res) {
                if (res.Success) {
                    _this.info = res.Result;
                } else {
                    _this.$toast(res.Message);
                }
            })
        },
        //发布订单 - 客户
        releaseClientJob() {
            if (!this.isLogin) {
                this.selfAlert("请先登录", this.login, false, 1);
            } else {
                this.isShowReleaseClientJobConfirmPanel = true;
            }
        },
        //同意发布订单须知
        entryReleaseClientJob() {
            this.closeReleaseClientJobConfirmPanel();
            this.$router.push({
                path: "/release/clientJob",
            });
        },
        //关闭发布订单须知面板
        closeReleaseClientJobConfirmPanel() {
            this.isShowReleaseClientJobConfirmPanel = false;
        },
        //我的发单
        myReleaseOrders() {
            if (!this.isLogin) {
                this.selfAlert("请先登录", this.login, false, 1);
            } else {
                this.$router.push({
                    path: "/release/clientJobList/1",
                    query: {
                        // tabid: 0
                    }
                });
            }
        },
        //我的派单 - 我的订单列表
        myWorkOrders() {
            if (!this.isLogin) {
                this.selfAlert("请先登录", this.login, false, 1);
            } else {
                this.$router.push({
                    path: "/distributedOrderList",
                    query: {
                        tabid: 0
                    }
                });
            }
        },
        login() {
            let self = this;
            dsBridge.call("login", "", function(session) {
                window.sessionStorage.setItem("session", session);
                self.init();
            });
        },
        logout() {
            dsBridge.call("logout", {});
            dsBridge.call("closeWindow", {});
        },
        //展示帮助详情开关
        switchHelpDetail(item) {
            if (item && item.id) {
                this.curHelpDetail = JSON.parse(JSON.stringify(item));
            }
            this.isShowHelpDetail = !this.isShowHelpDetail;
        },
        //未开通
        upcoming() {
            let tipCont = "<p>我们即将上线</p><p>为您提供更全、更舒心的服务</p><p>敬请期待…</p>";
            this.selfAlert(tipCont, false, false, 1);
        },
        //提示
        selfAlert(cont, callback, cancelauto, dialogType, cancelBack) {
            let self = this;
            self.alert = {
                cont: cont,
                callback: callback ? callback : false,
                cancelauto: cancelauto ? cancelauto : false,
                dialogType: dialogType ? dialogType : 1,
                cancelBack: cancelBack ? cancelBack : false,
            };
            self.alert = self.$uAlert.show_alert(self.alert);
        },
    },
}


// WEBPACK FOOTER //
// ./src/ally/page/user/center.js